import { render } from "./AttributeInForm.vue?vue&type=template&id=134a9022&scoped=true"
import script from "./AttributeInForm.vue?vue&type=script&lang=js"
export * from "./AttributeInForm.vue?vue&type=script&lang=js"

import "./AttributeInForm.vue?vue&type=style&index=0&id=134a9022&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-134a9022"]])

export default __exports__